// hooks/useChat.js
import { useState, useEffect, useRef, useCallback } from "react";
import WebSocketService from "../services/websocket";
import {
  getSelectedCompany,
  getUserDetails,
  getSelectedDms,
  getUserToken,
} from "../utils/auth";
import { getAdminId } from "../utils/authId";
import { toast } from "react-toastify";

const useChatDMS = (refreshChat) => {
  const [text, setText] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const inputRef = useRef(null);
  const [sendingmessage, setSendingMessage] = useState([]);
  const userData = getUserDetails() || {};
  const selectedDms = getSelectedDms() || {};
  const selectedUser = selectedDms || {};
  const selectedComp = getSelectedCompany();
  const adminId = getAdminId();
  const [recivingMessage, setRecivingMessage] = useState([]);
  const [reactions, setReactions] = useState([]);
  const [typing, setTyping] = useState("");
  const [mentionInfo, setMentionInfo] = useState([]); // NEW
  const menstion_id = [...new Set(mentionInfo?.map((id) => id.id))];

  // const [isSending, setIsSending] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [pendingMessages, setPendingMessages] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const debouncedTyping = useCallback(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    const newTimeout = setTimeout(() => {
      WebSocketService.typingUser(selectedUser?.chat_unique);
    }, 100); // Send typing indicator every 300ms instead of on every keystroke

    setTypingTimeout(newTimeout);
  }, [selectedUser?.chat_unique, typingTimeout]);

  useEffect(() => {
    const token = getUserToken();

    WebSocketService.connect(
      token,
      selectedUser?.chat_unique,
      selectedUser?.is_group_chat
    );
    WebSocketService.markMessageAsRead(
      selectedUser?.is_group_chat,
      selectedUser?.chat_unique
    );
    const messageHandler = (data) => {
      const now = new Date();
      if (data.message.message_type === "sent" && data.message.status === 200) {
        setPendingMessages(false);
        setTyping("");
        const newMessage = {
          message: data.message.content,
          file_url: data.message.file_url,
          time: data?.message.time,
          date: now.toISOString().split("T")[0],
          emp_pic: userData.emp_pic,
          message_id: data.message.message_id,
          user_id: data?.message.user_id,

          // Or current user's avatar path
        };
        setSendingMessage((prev) => [...prev, newMessage]);
      }
      if (data.receiver !== selectedUser?.chat_unique) return;

      if (data.message.message_type === "received") {
        if (data.message.reaction === "reaction") {
          setReactions({
            reaction: data.message.reactions[0],
            action: data.message.emoji_add_or_remove,
            sender_id: data.sender,
          });
          return;
        }
        if (data.is_typing === "typing") {
          setTyping("typing");
          setTimeout(() => setTyping(null), 1000);
          return;
        }

        WebSocketService.markMessageAsRead(
          selectedUser.is_group_chat,
          selectedUser.chat_unique
        );
        const latestMessage = {
          name: data.message.name,
          message: data.message.content,
          file_url: data.message.file_url,
          time: data?.message.time,
          date: now.toISOString().split("T")[0],
          emp_pic: data.message.emp_pic,
          message_id: data.message.message_id,
          user_id: data?.message.user_id,
        };
        setRecivingMessage((prev) => {
          if (
            prev.some(
              (msg) =>
                msg.message === latestMessage.message &&
                msg.time === latestMessage.time
            )
          ) {
            return prev;
          }
          return [...prev, latestMessage];
        });
        setTyping("");
      }
    };

    const errorHandler = (error) => {
      // toast.error("Unable to send message. Please try again.", {
      //   position: "top-center",
      //   autoClose: 3000,
      //   closeButton: false,
      //   className: "custom_toast",
      // });
    };

    WebSocketService.registerCallbacks({
      onmessage: messageHandler,
      onerror: errorHandler,
    });

    return () => {
      WebSocketService.registerCallbacks({
        onmessage: null,
        onerror: null,
      });
    };
  }, [
    selectedUser?.chat_unique,
    refreshChat,
    selectedUser?.register_id,
    selectedUser?.is_group_chat,
    userData.emp_pic,
  ]);

  const replaceMentionsWithTags = (deltaOps) => {
    if (!Array.isArray(deltaOps)) {
      console.error("deltaOps is not an array:", deltaOps);
      return [];
    }

    return deltaOps.reduce((acc, op) => {
      let currentOp = { ...op };

      // Convert emoji images to unicode
      if (
        currentOp.insert &&
        typeof currentOp.insert === "object" &&
        currentOp.insert.image &&
        currentOp.insert.image.includes(
          "cdn.jsdelivr.net/npm/emoji-datasource-apple"
        )
      ) {
        const hexParts = currentOp.insert.image
          .match(/\/([^/]+)\.png$/)?.[1]
          .split("-");

        if (hexParts) {
          try {
            const codePoints = hexParts.map((hex) => parseInt(hex, 16));
            if (!codePoints.some(isNaN)) {
              const emoji = String.fromCodePoint(...codePoints);
              currentOp = { insert: emoji };
            }
          } catch {
            // Keep original if conversion fails
          }
        }
      }

      // Process mentions in text inserts
      if (currentOp.insert && typeof currentOp.insert === "string") {
        let text = currentOp.insert;
        let lastIndex = 0;
        const mentionRegex = /@([^\s]+)/g;
        let match;

        while ((match = mentionRegex.exec(text)) !== null) {
          const mentionText = match[0]; // e.g. "@Issac"
          const username = match[1]; // e.g. "Issac"

          // Find the mentioned user in mentionInfo
          const mentionedUser = mentionInfo.find(
            (user) => user.first_name === username
          );

          // Add text before the mention
          if (match.index > lastIndex) {
            acc.push({
              insert: text.substring(lastIndex, match.index),
              attributes: currentOp.attributes || {}, // ✅ Preserve attributes
            });
          }

          // Add the mention if found, otherwise add as plain text
          if (mentionedUser) {
            acc.push({
              insert: `<@${mentionedUser.id}>`,
              attributes: { ...(currentOp.attributes || {}), mention: true }, // ✅ merge attributes
            });
          } else {
            acc.push({
              insert: mentionText,
              attributes: currentOp.attributes || {}, // ✅ Preserve attributes
            });
          }

          lastIndex = match.index + mentionText.length;
        }

        // Add remaining text after last mention
        if (lastIndex < text.length) {
          acc.push({
            insert: text.substring(lastIndex),
            attributes: currentOp.attributes || {}, // ✅ Preserve attributes
          });
        }

        return acc;
      }

      // Add new insert if not merged
      acc.push(currentOp);
      return acc;
    }, []);
  };

  const getFileExtension = (fileName) => {
    return fileName.split(".").pop().toLowerCase();
  };

  const convertFileToBase64 = async (file) => {
    try {
      const reader = new FileReader();
      const promise = new Promise((resolve, reject) => {
        reader.onload = () => {
          const base64Data = reader.result.split(",")[1];
          resolve({
            file_name: file.name,
            file_data: base64Data,
            file_type: file.type,
            file_extension: getFileExtension(file.name),
          });
        };
        reader.onerror = (error) => reject(error);
      });
      reader.readAsDataURL(file);
      return await promise;
    } catch (error) {
      throw error;
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const remainingSlots = 5 - uploadedFiles.length;
    const maxFileSize = 1024 * 1024 * 1024; // 1 GB in bytes

    // Filter out files > 1 GB
    const oversizedFiles = files.filter((file) => file.size > maxFileSize);
    if (oversizedFiles.length > 0) {
      toast.info("Each file must be less than 1 GB.", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }

    const validFiles = files.filter((file) => file.size <= maxFileSize);

    if (validFiles.length > remainingSlots) {
      toast.error(
        `You can only upload ${remainingSlots} more file${
          remainingSlots > 1 ? "s" : ""
        }.`,
        {
          position: "top-center",
          autoClose: 2000,
          closeButton: false,
          className: "custom_toast",
        }
      );
    }

    const limitedFiles = validFiles.slice(0, remainingSlots);

    const allFiles = limitedFiles.map((file) => {
      const previewUrl = file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null;

      return {
        id: crypto.randomUUID(), // ✅ unique id
        file,
        name: file.name,
        type: file.type,
        url: previewUrl,
        loading: true,
      };
    });

    setUploadedFiles((prevFiles) => {
      const updatedFiles = [...prevFiles, ...allFiles];
      allFiles.forEach((file, index) => {
        setTimeout(() => {
          setUploadedFiles((prev) =>
            prev.map((f, i) =>
              prevFiles.length + index === i ? { ...f, loading: false } : f
            )
          );
        }, 2000);
      });
      return updatedFiles;
    });
  };

  const handleRemoveFile = (id) => {
    const fileToRemove = uploadedFiles.find((f) => f.id === id);
    if (fileToRemove?.url) {
      URL.revokeObjectURL(fileToRemove.url);
    }
    setUploadedFiles((prev) => prev.filter((f) => f.id !== id));
  };

  const handleChange = useCallback(
    (e) => {
      if (!isSending) {
        debouncedTyping();
      }
      const message = e?.target?.innerText || e;
      setText(message);
    },
    [debouncedTyping, isSending]
  );

  const clearSendingMessage = useCallback(() => {
    setSendingMessage([]);
  }, []);

  const clearRecivingMessage = useCallback(() => {
    setRecivingMessage([]);
  }, []);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleSend = async () => {
    setPendingMessages(true); // Show loader
    setIsSending(true); // 🔑 prevent typing signal
    if (typingTimeout) {
      clearTimeout(typingTimeout);
      setTypingTimeout(null);
    }
    setUploadingFiles(uploadedFiles.map((file) => file.name));
    await delay(500);

    try {
      const filesData = await Promise.all(
        uploadedFiles.map(async (fileItem) => {
          return convertFileToBase64(fileItem.file);
        })
      );

      const cleanedMessage = replaceMentionsWithTags(text);

      const messageData = {
        admin: adminId,
        company: [selectedComp.id],

        // ...(!mentionInfo && {
        //   message: text ? JSON.stringify(text) : null,
        // }),
        chat_unique_id: selectedUser.chat_unique,
        files: filesData,

        chat_name:
          selectedUser.is_group_chat === "0"
            ? "private"
            : selectedUser.is_group_chat === "1"
            ? "group"
            : "channel",
        register_id: userData.id,
        users_list: [userData.id, selectedUser.register_id],
        message: text ? JSON.stringify(cleanedMessage) : [],
      };
      if (mentionInfo.length > 0) {
        messageData.is_mention = "mentioned";
        messageData.mention_user_id = menstion_id;
      }
      if (inputRef.current) {
        inputRef.current.style.height = "auto";
      }
      //   setText('');
      setUploadedFiles([]);
      WebSocketService.sendMessage(messageData);

      setText([]);
      setUploadedFiles([]);
    } catch (error) {
      setPendingMessages(false);
      toast.error("Unable to send message. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        closeButton: false,
        className: "custom_toast",
      });
      console.error("Failed to send message:", error);
    } finally {
      // setIsSending(false);
      setIsSending(false); // 🔑 allow typing again
      setUploadingFiles([]);
      setPendingMessages(false);
    }
  };

  useEffect(() => {
    return () => {
      uploadedFiles.forEach((item) => {
        if (item.url) URL.revokeObjectURL(item.url);
      });
    };
  }, [uploadedFiles]);

  return {
    text,
    setText,
    uploadedFiles,
    inputRef,
    handleFileChange,
    handleRemoveFile,
    handleSend,
    handleChange,
    reactions,
    typing,
    insertMentionUser: setMentionInfo,
    sendingmessage,
    recivingMessage,
    clearSendingMessage,
    clearRecivingMessage,
    pendingMessages, // Expose pending messages
    setPendingMessages,
    // isSending,
    uploadingFiles,
    setUploadedFiles,
    setTyping,
  };
};

export default useChatDMS;
